import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, ButtonGroup, Well } from 'react-bootstrap';
import calculator from '../partials/CalculatorHOC';
import { IconBox, ToggleSwitch } from 'components';
import { Map, DataLayer } from 'google-react-maps';
import Select from 'react-select';
import _ from 'lodash';

class MapPlanCalculator extends React.Component {
  constructor(props) {
    super(props);


    this.handleClickRegionSelect = this.handleClickRegionSelect.bind(this);
    this.handleClickNationalSelect = this.handleClickNationalSelect.bind(this);
    this.handleMapRegionSelectChange = this.handleMapRegionSelectChange.bind(this);
    this.customCityComponent = this.customCityComponent.bind(this);
    this.customStateComponent = this.customStateComponent.bind(this);
    this.customNationalComponent = this.customNationalComponent.bind(this);

    this.city_regions = (this.props.map_regions || [])
    .filter(r => /^\/plans\/city.+$/i.test(r.path))
    .map(r => ({ value: r.path, label: r.name }));

    this.state_regions = (this.props.map_regions || [])
    .filter(r => /^\/plans\/state.+$/i.test(r.path))
    .map(r => ({ value: r.path, label: r.name }));
  }

  handleClickRegionSelect() {
    if(!this.props.map_interval) {
      $('.map-interval-buttons').animateBounce();
    }
  }
  handleClickNationalSelect() {
    if(!this.props.map_interval) {
      $('.map-interval-buttons').animateBounce();
    }
    else {
      this.props.handleSelectNationalPlan();
    }
  }
  handleMapRegionSelectChange(regions, type) {
    const add_geo = type == 'map_city' ?
    regions.length > this.props.selected_map_city_regions.length :
    regions.length > this.props.selected_map_state_regions.length
    if(add_geo) {
      this.props.addGeoJson(_.last(regions).value);
    }
    else {
      const combined_regions_list = type == 'map_city' ?
      [ ...this.props.selected_map_state_regions.map(region => this.state_regions.find(r => r.value == region)), ...regions.map(r => r) ] :
      [ ...this.props.selected_map_city_regions.map(region => this.city_regions.find(r => r.value == region)), ...regions.map(r => r) ];
      const [ removed_geo ] = _.differenceWith(this.props.geo_json_data, combined_regions_list, (a, b) => a.properties.name == b.label);
      if(removed_geo) {
        this.props.removeGeoJson(removed_geo.properties.name);
      }
    }
    this.props.handleMapRegionsChange(regions.map(r => r.value), type);
  }
  customCityComponent() {
    const map_city_yearly_price = (+(this.props.plans.find(p => p.type == 'map_city' && p.interval == 'year').amount) / 100).toFixed(2);
    const map_city_monthly_price = (+(this.props.plans.find(p => p.type == 'map_city' && p.interval == 'month').amount) / 100).toFixed(2);

    return (
      <div className='map-plan-select-container map-plan-custom-component-container'>
        <hr className='dotted short' />
        <Row>
          <Col md={12} xs={12}>
            <h5>{`$${map_city_monthly_price}/month - $${map_city_yearly_price}/year`}</h5>
          </Col>
        </Row>
        <Row className='mb-lg'>
          <Col md={12} xs={12}>
            <div onClick={this.handleClickRegionSelect}>
              <Select
                options={this.city_regions}
                onChange={regions => this.handleMapRegionSelectChange(regions, 'map_city')}
                multi={true}
                value={this.props.selected_map_city_regions}
                placeholder='Select City Regions'
                disabled={this.props.selected_map_national_plan || !this.props.map_interval}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
  customStateComponent() {
    const map_state_yearly_price = (+(this.props.plans.find(p => p.type == 'map_state' && p.interval == 'year').amount) / 100).toFixed(2);
    const map_state_monthly_price = (+(this.props.plans.find(p => p.type == 'map_state' && p.interval == 'month').amount) / 100).toFixed(2);

    return (
      <div className='map-plan-select-container map-plan-custom-component-container'>
        <hr className='dotted short' />
        <Row>
          <Col md={12} xs={12}>
            <h5>{`$${map_state_monthly_price}/month - $${map_state_yearly_price}/year`}</h5>
          </Col>
        </Row>
        <Row className='mb-lg'>
          <Col md={12} xs={12}>
            <div onClick={this.handleClickRegionSelect}>
              <Select
                options={this.state_regions}
                onChange={regions => this.handleMapRegionSelectChange(regions, 'map_state')}
                multi={true}
                value={this.props.selected_map_state_regions}
                placeholder='Select States'
                disabled={this.props.selected_map_national_plan || !this.props.map_interval}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
  customNationalComponent() {
    const map_national_yearly_price = (+(this.props.plans.find(p => p.type == 'map_national' && p.interval == 'year').amount) / 100).toFixed(2);
    const map_national_monthly_price = (+(this.props.plans.find(p => p.type == 'map_national' && p.interval == 'month').amount) / 100).toFixed(2);

    return (
      <div className='map-plan-custom-component-container map-national-plan-custom-component-container'>
        <hr className='dotted short' />
        <Row>
          <Col md={12} xs={12}>
            <h5>{`$${map_national_monthly_price}/month - $${map_national_yearly_price}/year`}</h5>
          </Col>
        </Row>
        <ToggleSwitch
          on_condition={this.props.selected_map_national_plan}
          type='primary'
          onClick={this.handleClickNationalSelect}
        />
      </div>
    );
  }
  componentWillUpdate(next_props) {
    const { maps_total: next_total } = next_props;
    const { maps_total: curr_total } = this.props;

    if(next_total > curr_total && !next_props.selected_map_national_plan) {
      if(
        (next_props.map_interval == 'year' && next_total >= 350000) ||
        (next_props.map_interval == 'month' && next_total >= 35000)
      ) {
        this.props.handleForceNationalPlan();
      }
    }
  }

  render() {
    const { plans } = this.props;
    const map_styles = {
      position: 'relative',
      width: '100%',
      height: '600px',
    };

    return (
      <div className='animated fadeIn'>
        <Row className='mt-lg'>
          <Col md={4} xs={12}>
            <Well>
              <Row>
                <Col md={12} xs={12}>
                  <h4>Select Pricing interval</h4>
                </Col>
              </Row>
              <Row>
                <Col md={12} xs={12}>
                  <div className='map-interval-buttons'>
                    <ButtonGroup justified>
                      <Button
                        onClick={() => this.props.handleIntervalChange('month')}
                        active={this.props.map_interval == 'month'}
                        >
                        Monthly
                      </Button>
                      <Button
                        onClick={() => this.props.handleIntervalChange('year')}
                        active={this.props.map_interval == 'year'}
                        >
                        Yearly
                      </Button>
                    </ButtonGroup>
                  </div>
                </Col>
              </Row>
            </Well>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4}>
            <IconBox
              show_icon={false}
              title={`CITY REGIONS`}
              body='City regions give you access to all maps in the area shown on the map below'
              height={200}
              CustomComponent={this.customCityComponent()}
            />
          </Col>
          <Col xs={12} md={4}>
            <IconBox
              show_icon={false}
              title={`STATE REGIONS`}
              body='State regions give you access to all maps within the selected states'
              height={200}
              CustomComponent={this.customStateComponent()}
            />
          </Col>
          <Col xs={12} md={4}>
            <IconBox
              show_icon={false}
              title={`NATIONAL PLAN`}
              body='A national plan will give you access to all maps in the US'
              height={200}
              CustomComponent={this.customNationalComponent()}
            />
          </Col>
        </Row>
        <Map
          api-key='AIzaSyCWuH5SGDikY4OPSrbJxqTi4Y2uTgQUggw'
          style={map_styles}
          center={{ lat: 39.0997, lng: -100.5786 }}
          zoom={4}
          >
          {!this.props.selected_map_national_plan ?
          this.props.geo_json_data.map(d => <DataLayer key={d.properties.name} zIndex={2} geoJson={d}/>) :
          null}
        </Map>
      </div>
    )
  }
}

MapPlanCalculator.PropTypes = {
  plans: PropTypes.arrayOf(PropTypes.object).isRequired,
  map_regions: PropTypes.arrayOf(PropTypes.object).isRequired,
  show_map_visual: PropTypes.bool,
  fetching_geo_json: PropTypes.bool,
  state_geos: PropTypes.arrayOf(PropTypes.object),
  city_geos: PropTypes.arrayOf(PropTypes.object)
};

module.exports = calculator(MapPlanCalculator);



// WEBPACK FOOTER //
// ./src/browser/components/settings/subscriptions/plans_calculator/partials/MapPlanCalculator.js